import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAH1gEECv7ZPF4scMPHxkLnxn-hZx9H4YE",
  authDomain: "linkedin-clone-niranjanv849.firebaseapp.com",
  projectId: "linkedin-clone-niranjanv849",
  storageBucket: "linkedin-clone-niranjanv849.appspot.com",
  messagingSenderId: "844207016819",
  appId: "1:844207016819:web:312ebc0c48366861fcd306",
  measurementId: "G-7W188SP8EH",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();

export { auth, provider, storage };
export default db;
